<template>
  <div>
    <div v-if="$auth.policies['view-survey']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="$route.meta.title"
            :link="[{ text: 'Học sinh', href: '#' }, { text: $route.meta.title }]"
          />
        </div>
        <v-btn
          v-if="$auth.policies['create-survey']"
          depressed
          dark
          color="#0D47A1"
          @click="$refs.popupSurvey.openDialog()"
        >
          <v-icon left>add</v-icon>Thêm khảo sát</v-btn
        >
      </div>
      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0"><SurveyFilter /> </v-card>
      <v-card outlined class="mx-4 elevation-0"><SurveyTable /> </v-card>
    </div>
    <div v-else>
      <Page403></Page403>
    </div>
    <PopupSurvey ref="popupSurvey" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import Page403 from '@/views/Page403.vue'
import SurveyTable from '../../../modules/survey/survey/SurveyTable.vue'
import SurveyFilter from '../../../modules/survey/survey/SurveyFilter.vue'
import PopupSurvey from '../../../modules/survey/survey/PopupSurvey.vue'
export default {
  components: { Breadcrumbs, Page403, SurveyTable, SurveyFilter, PopupSurvey }
}
</script>
<style scoped>
.table .gray--text {
  margin-right: 10px;
  margin-bottom: 50px;
  color: gray;
  padding-right: 24px;
  padding-bottom: 4px;
}
</style>
